export default __webpack_public_path__ + "static/media/quality.51c481b3.svg";